<script setup lang="ts">
import { useFieldValue } from 'vee-validate';
import VeeImageField from '@/components/forms/ImageField/VeeImageField.vue';
import { watch } from 'vue';

const profilePictureId = useFieldValue<string | undefined>('profilePictureId');
import { sectionUserManagement } from '@/components/icons/icons';
import { SmartCropMode } from '@/api/generator';
import { DESKTOP_IMAGE_WIDTH_DETAIL, MOBILE_IMAGE_WIDTH_DETAIL } from '@/components/images/utils';

const emits = defineEmits<{
  update: [];
}>();

watch(profilePictureId, () => {
  emits('update');
});
</script>

<template>
  <VeeImageField
    name="profilePictureId"
    :mobileWidth="MOBILE_IMAGE_WIDTH_DETAIL"
    :desktopWidth="DESKTOP_IMAGE_WIDTH_DETAIL"
    :aspectRatio="1"
    :fallbackIcon="sectionUserManagement"
    :cropMode="SmartCropMode.Attention"
    rounded="circle"
    cover
  />
</template>
